export const GET_USER_MODERATION_REPORT_GROUPS = 'GET_USER_MODERATION_REPORT_GROUPS'
export const SET_USER_MODERATION_REPORT_GROUPS = 'SET_USER_MODERATION_REPORT_GROUPS'
export const UPDATE_USER_MODERATION_REPORT_GROUP = 'UPDATE_USER_MODERATION_REPORT_GROUP'
export const SET_STATUS_FILTER = 'SET_STATUS_FILTER'

export function getUserModerationReportGroups ({ data } = {}) {
  return {
    type: GET_USER_MODERATION_REPORT_GROUPS,
    payload: { data },
  }
}

export function setUserModerationReportGroups ({ data } = {}) {
  return {
    type: SET_USER_MODERATION_REPORT_GROUPS,
    payload: { data },
  }
}

export function updateUserModerationReportGroup ({ data } = {}) {
  return {
    type: UPDATE_USER_MODERATION_REPORT_GROUP,
    payload: { data },
  }
}

export function setStatusFilter ({ filter } = {}) {
  return {
    type: SET_STATUS_FILTER,
    payload: { filter },
  }
}
